<template>

  <v-card flat outlined v-if="provider" class="fill-height">

    <v-card-title class="secondary white--text">
      <h3 class="headline">{{provider.properties.ProviderName}}</h3>
    </v-card-title>

    <v-card-text class="info yellow--text text--lighten-3 pt-2">
      {{provider.properties.Description}}
    </v-card-text>

    <v-card-text>

      <v-container fluid grid-list-lg>

        <v-layout>

          <v-flex xs6>

            <v-simple-table id="provider-info" dense light class="transparent xs-small-table">
              <tbody>
              <tr>
                <th>Service Category:</th>
                <td>{{provider.properties.Category}}</td>
              </tr>
              <tr>
                <th>Service Type:</th>
                <td>{{provider.properties.Type}}</td>
              </tr>
              <tr v-if="provider.properties.URL">
                <th>Website:</th>
                <td><a :href="provider.properties.URL"
                       v-text="provider.properties.URL"
                       target="_blank"></a></td>
              </tr>
              <tr v-if="provider.properties.PhoneContact">
                <th>Customer Service:</th>
                <td>{{provider.properties.PhoneContact}}</td>
              </tr>
              <tr>
                <th>Technology:</th>
                <td style="max-width: 350px;" class="text-xs-justify">
                  {{provider.properties.Technology}}
                </td>
              </tr>
              <tr>
                <th>Backhaul:</th>
                <td>{{provider.properties.Backhaul}}</td>
              </tr>
              <tr v-if="provider.properties.Pros">
                <th>Pros:</th>
                <td>
                  <div color="info" v-for="(c,i) in provider.properties.Pros.split(';')"
                       :key="i" class="mr-1 mb-1 d-block" label x-small>
                    <v-icon small left color="green">mdi-arrow-right-box</v-icon>
                    {{c}}
                  </div>
                </td>
              </tr>
              <tr v-if="provider.properties.Cons">
                <th>Cons:</th>
                <td>
                  <div color="warning" v-for="(c,i) in provider.properties.Cons.split(';')"
                       :key="i" class="mr-1 my-0 d-block" label x-small>
                    <v-icon small left color="orange">mdi-arrow-right-box</v-icon>
                    {{c}}
                  </div>
                </td>
              </tr>
              </tbody>
            </v-simple-table>

            <v-divider class="my-3"></v-divider>

            <div class="d-flex">

              <h6 class="grey--text subtitle-1">
                Areas Served
              </h6>

              <v-spacer></v-spacer>

              <v-switch v-model="useWizardPreferences"
                        label="Use Wizard Choices"
                        hide-details
                        class="pa-0 ma-0"></v-switch>
            </div>

            <div class="overflow-y-auto" style="max-height: 380px;">

              <ServiceAreasTable
                :items="features"
                :blacklist="['properties.ProviderName', 'properties.Type']"
                :sort-by="'properties.Location'"
                :sort-desc="false"
                hide-default-footer
                :dense="true"
                disable-pagination
                @row-clicked="handleRowClick"
              ></ServiceAreasTable>

            </div>

          </v-flex>

          <v-flex xs6>

            <v-card class="pa-2" style="width: 100%;" v-if="mapVisible">

              <StandardMap ref="mapContainer"

                           :min-width="450"
                           :min-height="650"
                           :max-height="650"
                           :padding="[0, 200]"

                           :can-identify="false"
                           :show-card="false"
                           :symbolized-layer="false"

                           :features="features"

                           @map-ready="handleMapReady"
              >

                <l-control>
                  <v-btn small depressed block
                         color="primary--text" map does NOT exist
                         class="black--text mt-2"
                         @click="clearSelectedAndZoomToAll">
                    <v-icon left>mdi-arrow-expand-all</v-icon>
                    Show All Service Areas
                  </v-btn>

                </l-control>

                <ServiceAreasLayer display-labels
                                   :features="features"
                ></ServiceAreasLayer>

                <SelectedFeatureLayer></SelectedFeatureLayer>

              </StandardMap>

            </v-card>


          </v-flex>

        </v-layout>

      </v-container>

    </v-card-text>

  </v-card>

</template>

<script>
import intersection from 'lodash/intersection';

import ServiceAreasTable from './tables/ServiceAreasTable';
import StandardMap from './map-components/StandardMap.vue';

import SelectedFeatureLayer from './map-components/SelectedFeatureLayer';
import ServiceAreasLayer from './map-components/ServiceAreasLayer';

const name = 'Provider.Card';

export default {

  name,

  components: { ServiceAreasTable, StandardMap, SelectedFeatureLayer, ServiceAreasLayer },

  props: {},

  data() {
    return {
      map: null,
      mapVisible: false,
      useWizardPreferences: false,
    };
  },

  mounted() {
    setTimeout(() => {
      this.mapVisible = true;
    }, 250);

    if (this.$route.query.referrer === 'wizard-offerings') {
      this.useWizardPreferences = true;
    }
  },

  computed: {

    provider() {
      return this.$store.state.data.providers.find(p => p.properties.ProviderID === this.$route.params.id);
    },

    features() {
      const providerServices = this.$store.getters.servicesById(this.$route.params.id);
      if (this.useWizardPreferences && this.$store.getters.filteredServiceAreas.length) {
        return intersection(providerServices, this.$store.getters.filteredServiceAreas);
      }
      return providerServices;
    },

  },

  methods: {

    handleMapReady(map) {
      console.warn('handleMapReady');
      this.map = map;
    },

    handleRowClick(feature) {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          service: feature.id,
        },
      });
    },

    clearSelectedAndZoomToAll() {
      const query = { ...this.$route.query };
      delete query.service;
      this.$router.push({
        query,
      });
    },

  },

};
</script>

<style>

  .v-data-table-header {
    background-color: #eaeaea;
  }

  #provider-info th {
    text-align: right;
    width: 150px;
  }

</style>
